import { render, staticRenderFns } from "./MobUpcomingCard.vue?vue&type=template&id=55194e09"
import script from "./MobUpcomingCard.vue?vue&type=script&lang=js"
export * from "./MobUpcomingCard.vue?vue&type=script&lang=js"
import style0 from "./MobUpcomingCard.vue?vue&type=style&index=0&id=55194e09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports